// supported client groupings for sites, must match the Location service's
// ClientSlug enum, adding a client is a code change on both sides by design
export const SUPPORTED_CLIENTS: Record<string, string> = {
  amazon: 'Amazon',
};

export const CLIENTS_LIST = Object.entries(SUPPORTED_CLIENTS).map(([value, text]) => ({
  text,
  value,
}));
